import { getCategoryInfo } from '../category';
import { getDealType } from './getDealType';
import { getObjectType } from './getObjectType';

export const getDealAndObjectType = (category: string | undefined) => {
  const categoryInfo = getCategoryInfo(category);

  const dealType = getDealType(categoryInfo);
  const objectType = getObjectType(categoryInfo);

  return {
    dealType,
    objectType,
  };
};
